module.exports = __webpack_public_path__ + "static/img/payzw.a004ff88.png";